<template>
  <div class="orders">
    <form action="/" method="POST" id="payment-form">
      <input type="hidden" name="token" />
      <div class="group">
        <h1>Purchase #AFGMT</h1>
        <br />
        <br />

        <p style="font-size:20px">
          "Impressive techno-magic!"
          <br />
          <b>- Jeff McBride</b>
        </p>
        <br />
        <br />

        <p style="font-size:20px">
          "OMG What Just Happened!"
          <br />
          <b>- Robert Ramirez</b>
        </p>
        <br />
        <br />

        <p style="font-size:20px">
          "“I looked and [couldn't find the trackers] in them!"
          <br />
          <b>- Craig Fillicetti of ProMystic</b>
        </p>

        <div style="text-align:left;padding: 10px">
          <br />
          <br />
          <br />
          <h2>Details, please read carefully</h2>
          <ul style="padding:30px">
            <li>Includes 400 business cards with trackers.</li>
            <li>Business card templates included, or you may provide your own art</li>
            <li>To protect your investment, an NDA must be signed after purchasing.</li>
            <li>Includes A Fucking Good Peek.</li>
            <li>Audience members do not need a smart phone, wifi or bluetooth.</li>
            <li>Cannot be exported out of the USA.</li>
            <li>1 year of tracking included. $5 monthly tracking fee thereafter.</li>
            <li>To maintain exclusivity, the set-up fee increases $10 everytime someone purchases it.</li>
          </ul>
          <b>Satisfaction is 100% Guaranteed.</b>
          <br />
          <br />
        </div>
      </div>

      <div class="group">
        <label>
          <span>Name</span>
          <input id="name" name="name" class="field" placeholder="Jane Doe" />
        </label>
        <label>
          <span>Phone</span>
          <input id="phone" name="phone" class="field" placeholder="304-555-1212" />
        </label>
        <label>
          <span>Email</span>
          <input id="email" name="email" class="field" placeholder="jane@afgmt.com" />
        </label>
      </div>
      <!-- <div class="group">
        <label>
          <span>Address</span>
          <input
            id="address-line1"
            name="address_line1"
            class="field"
            placeholder="77 Winchester Lane"
          >
        </label>
        <label>
          <span>Address (cont.)</span>
          <input id="address-line2" name="address_line2" class="field" placeholder>
        </label>
        <label>
          <span>City</span>
          <input id="address-city" name="address_city" class="field" placeholder="Coachella">
        </label>
        <label>
          <span>State</span>
          <input id="address-state" name="address_state" class="field" placeholder="CA">
        </label>
        <label>
          <span>ZIP</span>
          <input id="address-zip" name="address_zip" class="field" placeholder="92236">
        </label>
        <label>
          <span>Country</span>
          <input
            id="address-country"
            name="address_country"
            class="field"
            placeholder="United States"
          >
        </label>
      </div>-->
      <div class="group">
        <label>
          <span>Card</span>
          <div id="card-element" class="field"></div>
        </label>
      </div>
      <div id="price"></div>
      <button id="paymentbuttom" class="stripe" type="submit">Your price ${{price}}</button>
      (The next person pays ${{nextprice}})
      <div class="outcome">
        <div
          class="error"
        >Sorry payment did not succeed. Please contact seth@magicseth.com for help.</div>
        <div class="success">
          Your payment has been received. You will receive an e-mail with further instructions.
          <span
            class="token"
          ></span>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
// import Parallax from "vue-parallaxy";
// import VideoBg from "vue-videobg";
import { stripe, db } from "../main";

export default {
  name: "Orders",
  data() {
    return {
      price: 190,
      nextprice: 190
    };
  },
  mounted: function() {
    // Create a Stripe client.
    // var stripe = Stripe("pk_test_nxIrhrDx2HjOHj7pZ0xHZ9I400lFwmK9WZ");

    db.collection("values")
      .doc("price")
      .onSnapshot(
        snapshot => {
          if (this.price == 190) {
            this.price = snapshot.data().price;
          }
          this.nextprice = this.price + 10;
        },
        err => {
          alert("failed " + err);
        }
      );

    // Create an instance of Elements.
    var elements = stripe.elements();
    const http = this.$http;
    // alert(http);

    var card = elements.create("card", {
      hidePostalCode: true,
      style: {
        base: {
          iconColor: "#666EE8",
          color: "#31325F",
          lineHeight: "40px",
          fontWeight: 300,
          fontFamily: "Helvetica Neue",
          fontSize: "15px",

          "::placeholder": {
            color: "#CFD7E0"
          }
        }
      }
    });
    card.mount("#card-element");

    function setOutcome(result) {
      var successElement = document.querySelector(".success");
      var errorElement = document.querySelector(".error");
      successElement.classList.remove("visible");
      errorElement.classList.remove("visible");

      if (result.token) {
        // In this example, we're simply displaying the token
        // successElement.querySelector(".token").textContent = result.token.id;
        successElement.classList.add("visible");
      } else if (result.error) {
        errorElement.textContent = result.error.message;
        errorElement.classList.add("visible");
      }
    }

    card.on("change", function(event) {
      setOutcome(event);
    });
    var alreadySubmitted = false;
    var capturethis = this;
    document.querySelector("form").addEventListener("submit", function(e) {
      e.preventDefault();
      if (alreadySubmitted) {
        alert("We're already processing your payment... Just a moment.");
        return;
      }
      alreadySubmitted = true;
      var options = {
        name: document.getElementById("name").value,
        phone_number: document.getElementById("phone").value,
        email: document.getElementById("email").value,
        price: capturethis.price
        // address_line1: document.getElementById("address-line1").value,
        // address_line2: document.getElementById("address-line2").value,
        // address_city: document.getElementById("address-city").value,
        // address_state: document.getElementById("address-state").value,
        // address_zip: document.getElementById("address-zip").value,
        // address_country: document.getElementById("address-country").value
      };
      stripe.createToken(card, options).then(function(result) {
        setOutcome(result);
        if (result.error) {
          // Inform the user if there was an error.
          var errorElement = document.getElementById("card-errors");
          errorElement.textContent = result.error.message;
        } else {
          // Send the token to your server.
          stripeTokenHandler(result.token, options);
        }
      });
    });

    // Submit the form with the token ID.
    function stripeTokenHandler(token, options) {
      // alert("flying away " + token);
      // alert(http);
      // Insert the token ID into the form so it gets submitted to the server
      var form = document.getElementById("payment-form");
      var hiddenInput = document.createElement("input");
      hiddenInput.setAttribute("type", "hidden");
      hiddenInput.setAttribute("name", "stripeToken");
      hiddenInput.setAttribute("value", token.id);
      form.appendChild(hiddenInput);
      const params = options;
      params.stripeToken = token.id;
      params.email = options.email;
      params.phone = options.phone_number;
      params.name = options.name;

      var successElement = document.querySelector(".success");
      var errorElement = document.querySelector(".error");
      successElement.classList.remove("visible");
      errorElement.classList.remove("visible");

      http
        .post(
          "https://us-central1-afgmtcom.cloudfunctions.net/newSubscription",
          params
        )
        .then(
          function(response) {
            // eslint-disable-next-line
            console.log(response);
            // Success
            successElement.classList.add("visible");

            // alert("You have paid. Further instructions will come via e-mail.");
          },
          function(response) {
            // eslint-disable-next-line
            response = response;

            errorElement.classList.add("visible");

            // Error
            alert(response.data);
            alreadySubmitted = false;
          }
        );

      // Submit the form
      // form.submit();
    }
  },
  methods: {
    showEarly() {
      document.getElementById("early").style.display = "block";
    },
    buyEarlyBird(sku) {
      stripe
        .redirectToCheckout({
          items: [
            // Replace with the ID of your SKU
            { sku: sku, quantity: 1 }
            // { plan: "plan_EzvEKjAGSSV7K1", quantity: 1 }
          ],
          successUrl: "https://afuckinggoodmagictrick.com/#/success",
          cancelUrl: "https://afuckinggoodmagictrick.com/#/failure"
        })
        .then(result => {
          alert(result);
          // If `redirectToCheckout` fails due to a browser or network
          // error, display the localized error message to your customer
          // using `result.error.message`.
        });
    }
  }
};
</script>
<style>
ul {
  /* list-style-type: none; */
  padding: 300px;
}
.button-buy,
.button-error,
.button-warning,
.button-secondary {
  color: white;
  border-radius: 4px;
  width: 200px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
}

.button-buy {
  font-size: 2em;
  background: rgb(66, 142, 255); /* this is a green */
}

.button-error {
  background: rgb(202, 60, 60); /* this is a maroon */
}

.button-warning {
  background: rgb(223, 117, 20); /* this is an orange */
}

.button-secondary {
  background: rgb(66, 184, 221); /* this is a light blue */
}
/**
 * The CSS shown here will not be introduced in the Quickstart guide, but shows
 * how you can use CSS to style your Element's container.
 */
.StripeElement {
  box-sizing: border-box;

  height: 40px;

  padding: 10px 12px;

  border: 1px solid transparent;
  border-radius: 4px;
  background-color: white;

  box-shadow: 0 1px 3px 0 #e6ebf1;
  -webkit-transition: box-shadow 150ms ease;
  transition: box-shadow 150ms ease;
}

.StripeElement--focus {
  box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5 !important;
}

form * {
  font-family: "Helvetica Neue", Helvetica;
  font-size: 15px;
  font-variant: normal;
  padding: 0;
  margin: 0;
}

body {
  background: #e6ebf1;
  display: flex;
  justify-content: center;
  min-height: 100%;
}

form {
  max-width: 600px;
  margin: 20px 0;
}

.group {
  background: white;
  box-shadow: 0 7px 14px 0 rgba(49, 49, 93, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  margin-bottom: 20px;
}

label {
  position: relative;
  color: rgb(73, 81, 90);
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
}

.group label:not(:last-child) {
  border-bottom: 1px solid #f0f5fa;
}

label > span {
  width: 120px;
  text-align: right;
  margin-right: 30px;
}

.field {
  background: transparent;
  font-weight: 300;
  border: 0;
  color: #31325f;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
}

.field::-webkit-input-placeholder {
  color: #cfd7e0;
}

.field::-moz-placeholder {
  color: #cfd7e0;
}

button.stripe {
  float: left;
  display: block;
  background: #666ee8;
  color: white;
  box-shadow: 0 7px 14px 0 rgba(49, 49, 93, 0.1),
    0 3px 6px 0 rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  border: 0;
  margin-top: 20px;
  font-size: 15px;
  font-weight: 400;
  width: 100%;
  height: 40px;
  line-height: 38px;
  outline: none;
}

button.stripe:focus {
  background: #555abf;
}

button.stripe:active {
  background: #43458b;
}

.outcome {
  float: left;
  width: 100%;
  padding-top: 8px;
  min-height: 24px;
  text-align: center;
}

.success,
.error {
  display: none;
  font-size: 13px;
}

.success.visible,
.error.visible {
  display: inline;
}

.error {
  color: #e4584c;
}

.success {
  color: #666ee8;
}

.success .token {
  font-weight: 500;
  font-size: 13px;
}
</style>